import * as Msdyn365 from '@msdyn365-commerce/core';
import { ensureAuthenticated } from '../../utilities/is-authenticated';
import { trackedAction } from '../../utilities/track-execution-time';

/**
 * PostEventConfig Input Action
 */
export class PostEventConfigInput implements Msdyn365.IActionInput {
    public eventConfig: IEventConfig;
    constructor(eventConfig: IEventConfig) {
        this.eventConfig = eventConfig;
    }

    public getCacheKey = () => `PostEventConfig`;
    public getCacheObjectType = () => 'PostEventConfig';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

export interface IEventConfig {
    Notifications: IEventData[];
}
export interface IEventData {
    EventId: string;
    Active: boolean;
}
export interface IPostEventConfigResponse {
    '@odata.context'?: string;
    Success: boolean;
    Messages: IPostEventConfigMessage[];
}
export interface IPostEventConfigMessage {
    ReturnCode: number;
    MessageText: string;
    MessageReference1: string;
    MessageReference2: string;
}

export const isEventConfigSaved = (response: IPostEventConfigResponse | null): boolean =>
    !!response?.Messages?.length && response.Messages.every(message => message.ReturnCode === 200);

const createInput = (_: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new PostEventConfigInput({} as IEventConfig);
};

async function action(input: PostEventConfigInput, ctx: Msdyn365.IActionContext): Promise<IPostEventConfigResponse | null> {
    ensureAuthenticated(ctx);
    const response = await Msdyn365.sendRequest<IPostEventConfigResponse>(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/SetEventConfig`,
        'post',
        {
            eventConfig: input.eventConfig
        },
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${ctx.requestContext.user.token}`
            }
        }
    );
    if (response.status === 200 && response.data) {
        return { ...response.data };
    } else {
        return null;
    }
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IPostEventConfigResponse>>((input, ctx) => trackedAction(action, input, ctx, 'SetEventConfig')),
    id: 'PostEventConfig',
    input: createInput
});
